import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchCrops } from '../api/terrain.api';
import { useT } from '../i18n';
import { loteZoneOptions } from '../utils/lote-zone-options';

type Args = Parameters<typeof loteZoneOptions>;

/**
 * Opciones del selector "Lote o zona" con la etiqueta de cultivo · ciclo · estado en las zonas
 * que tienen cultivo. Es el único punto que arma el catálogo y los textos de la etiqueta.
 */
export function useLoteZoneOptions(lotes: Args[0], modules: Args[1], opts?: { campoOnly?: boolean }) {
  const t = useT();
  const { data: crops = [] } = useQuery({ queryKey: ['crops'], queryFn: fetchCrops, staleTime: 5 * 60_000 });
  return useMemo(() => loteZoneOptions(lotes, modules, {
    cropNames: new Map(crops.map((c) => [c.cropId, c.name])),
    statusLabels: t.terrain.status,
    closedLabel: t.common.zoneCycleClosed,
  }, opts), [lotes, modules, crops, t, opts?.campoOnly]);
}
